import axios from 'axios'
import { CURRENT_CONFIG } from './config'
import { message } from 'ant-design-vue'
import router from '/@/router'
import { ELocalStorageKey, ERouterName, EUserType } from '/@/types/enums'
import { clearWebSession } from '/@/utils/auth-session'
export * from './type'

const REQUEST_ID = 'X-Request-Id'
const NO_LIVE_STREAM_CODE = 13011
const STOP_LIVESTREAM_URL = '/live/streams/stop'
function getAuthToken () {
  return localStorage.getItem(ELocalStorageKey.Token)
}

function isNoLiveStreamStopResponse (response: any) {
  return Number(response?.data?.code) === NO_LIVE_STREAM_CODE &&
    String(response?.config?.url || '').includes(STOP_LIVESTREAM_URL)
}

function requestDiagnostic (config: any, status?: number, code?: string) {
  return {
    method: String(config?.method || 'GET').toUpperCase(),
    path: String(config?.url || '').split('?')[0],
    status,
    code,
    request_id: config?.headers?.[REQUEST_ID],
  }
}

const instance = axios.create({
  // withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
  // timeout: 12000,
})

instance.interceptors.request.use(
  config => {
    config.headers[ELocalStorageKey.Token] = getAuthToken()
    // config.headers[REQUEST_ID] = uuidv4()
    config.baseURL = CURRENT_CONFIG.baseURL
    return config
  },
  error => {
    return Promise.reject(error)
  },
)

instance.interceptors.response.use(
  response => {
    if (response.data.code && response.data.code !== 0 && !(response.config as any).skipErrorMessage && !isNoLiveStreamStopResponse(response)) {
      message.error(response.data.message)
    }
    return response
  },
  err => {
    // Axios Cancel lacks config on 0.21. A user pause (or superseded preview)
    // must not be reported as an outage by the shared error toast.
    if (axios.isCancel(err)) return Promise.reject(err)
    const skipErrorMessage = (err?.config as any)?.skipErrorMessage
    console.warn('HTTP request failed', requestDiagnostic(
      err?.config,
      err?.response?.status,
      err?.code,
    ))

    // @See: https://github.com/axios/axios/issues/383
    if (!err.response || !err.response.status) {
      if (!skipErrorMessage) {
        message.error('The network is abnormal, please check the backend service and try again')
      }
      return Promise.reject(err)
    }
    if (err.response?.status !== 200 && !skipErrorMessage) {
      message.error(`ERROR_CODE: ${err.response?.status}`)
    }
    // if (err.response?.status === 403) {
    //   // window.location.href = '/'
    // }
    if (err.response?.status === 401) {
      const flag: number = Number(localStorage.getItem(ELocalStorageKey.Flag))
      if (flag === EUserType.Pilot) {
        router.replace({ name: ERouterName.PILOT })
      } else {
        clearWebSession()
        router.replace({ name: ERouterName.PROJECT })
      }
    }

    return Promise.reject(err)
  },
)

export default instance
